export const SITE_NAME = "Hotel Picker";
export const SITE_DESCRIPTION = "Find the perfect hotel for your event attendees with ease.";
export const SUPPORT_EMAIL = "support@unifiedeventsolutions.com";
export const SUPPORT_PHONE = "512-379-8781";